import "./TrustsEstates.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StrategicPillars from "./sections/StrategicPillars";
import ThePlanningProcess from "./sections/ThePlanningProcess";
import FirmInformation from "@/reusable_sections/Footer";
export default function TrustsEstatesPage() {
  return <div>
      <MainNavigation />
      <StrategicPillars />
      <ThePlanningProcess />
      <FirmInformation />
    </div>;
}